/*
Suresh Peddavoora 01/14/2023 2698964415 Fixed Button Spacing Alignments
Ashraf 01/14/2023 2698964415 Fixed validation issues.
Ashraf 01/16/2023 2698964415 Fixed reusable data repo search issues.
Suresh Peddavoora 01/16/2023 2698964415 Fixed Font Size Alignments
Ashraf 01/20/2023 2698964415 added show dashboard field
Suresh peddavoora 02/21/2023 2698964415 TextFields and table alignments
 Rohini 03/01/2023 2698964415 worked on the code enhancements.
 */
import {Button, FormControl, FormHelperText, InputAdornment, InputLabel, MenuItem, Select, Tooltip} from '@material-ui/core';
import {Clear, Search} from '@material-ui/icons';
import {Form, Formik, getIn} from 'formik';
import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import SearchFields from '../GlobalFields/DataRepositories/SearchDataRepositories/index';
import {ArrowBack} from '@material-ui/icons';
import * as Yup from 'yup';
import {
  getNBFieldNames,
  postNBFields,
  resetData,
} from '../../../redux/reducers/IntermediateRepository';
import {ThemeContext} from '../../../themes/ThemeProvider';

const AddFieldForm = ({handleClose}) => {
  const dispatch = useDispatch();
  const [showSearch, setShowSearch] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [codePopover, setCodePopover] = useState(false);
  window.onclick = function() {
    setCodePopover(false);
  };
  const {status, nbFields} = useSelector(
    ({intermediateRepo}) => intermediateRepo,
  );
  console.log(nbFields, 'nbFields');
  const options = [
    {
      key: 'Yes',
      value: 'Y',
    },
    {
      key: 'No',
      value: 'N',
    },
  ];
  const initialValues = {
    type: '',
    field: {},
    newFieldName: '',
    showDashboard: 'N',
  };
  const checkFieldNameExist = (value) => {
    if (nbFields && nbFields?.length > 0 && value) {
      const ar = [];
      nbFields.filter((i) => {
        if (i?.nbFieldName.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string().nullable().required('Type is required'),
    field: Yup.mixed().test('field', 'Field is required', function(value, context) {
      const {parent} = context;
      if (!parent?.field?.fieldName) {
        return false;
      } else {
        return true;
      }
    }),
    newFieldName: Yup.string()
      .required('New field name is required')
      .test('code', 'Field Name already exist', (value) => !checkFieldNameExist(value)),
  });
  const handleGoBack = () => {
    setShowSearch(false);
  };

  useEffect(() => {
    if (status === 200 || status === 500) {
      setTimeout(() => {
        dispatch(resetData());
        handleClose();
      }, 2000);
    }
  }, [status]);
  useEffect(() => {
    dispatch(getNBFieldNames('New Account'));
  }, []);

  const handleSubmit = (values) => {
    const payload = {
      dmType: values.type,
      fieldName: values.field.fieldName,
      nbFieldName: values.newFieldName,
      repoFieldId: 0,
      repoName: values.field.repositoryName,
      repoType: values.field.fieldType,
      showDashboard: values?.showDashboard,
    };
    dispatch(postNBFields(payload));
  };

  const getFilterCodesData = (value) => {
    if (nbFields && nbFields?.length > 0) {
      return nbFields?.filter((i) => String(i?.nbFieldName)?.startsWith(value));
    } else {
      return [];
    }
  };
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {({values, setFieldValue, touched, errors, handleBlur, handleChange, resetForm}) => {
        return (
          <>
            {showSearch ? (
              <>
                <div className="new-standard-textfields mb-3">
                  <Button
                    variant="text"
                    className={`search-btn ml-3 ${classes.buttonRoot}`}
                    onClick={handleGoBack}
                  >
                    <ArrowBack className="mr-2" />
                  Go Back
                  </Button>
                </div>
                <SearchFields
                  // selectedRows={selectedRows}
                  // setReportFieldValue={setFieldValue}
                  // setSelectedRows={setSelectedRows}
                  isReports={true}
                  intermediateField={values.field}
                  mapFields={true}
                  setIntermediateField={setFieldValue}
                  // reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                  // sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                  tempSelectedRows={tempSelectedRows}
                  handleClose={handleGoBack}
                  setTempSelectedRows={setTempSelectedRows}
                // workQueue={workQueue}
                />
              </>
            ) : (
              <Form noValidate>
                <>
                  <div className="form-row mx-2 global-field-textfields new-standard-textfields">
                    <div className="col-lg-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="type"
                        id="type"
                        size="small"
                        value={values.type}
                        options={['New Account', 'New Payment']}
                        onChange={(e, value) => {
                          setFieldValue('type', value);
                          if (value) {
                            dispatch(getNBFieldNames(value));
                          }
                        }}
                        placeholder="Select Type"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              // className={`${classes.labelName} ${classes.selectLabel}`}
                              {...params}
                              variant="outlined"
                              error={getIn(touched, 'type') && getIn(errors, 'type')}
                              margin="dense"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              label="Type"
                              placeholder="Select Type"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText error>
                        {getIn(touched, 'type') && getIn(errors, 'type')}
                      </FormHelperText>
                    </div>
                    <div className="col-lg-4 form-group">
                      <GuiTextField
                        margin="dense"
                        // className={`${classes.labelName} ${classes.inputLabel}`}
                        variant="outlined"
                        placeholder={`Select Field`}
                        label="Field"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="field"
                        value={
                          values.field?.repositoryName ?
                            values.field?.repositoryName + '.' + values.field?.fieldName :
                            ''
                        }
                        onChange={(e) => {
                          // handleChange(e);
                          // setFieldValue("eventTactic", e.target.value);
                        }}
                        fullWidth
                        handleBlur={handleBlur}
                        required
                        error={getIn(touched, 'field') && !values.field?.fieldName && getIn(errors, 'field')}
                        disabled
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title={'Search'}>
                                <Search
                                  className={` ${classes.iconSearch} mt-0`}
                                  onClick={() => {
                                    setShowSearch(true);
                                    //   setCardSpace(true);
                                    //   setSearchEventTactics(true);
                                  }}
                                  size="sm"
                                />
                              </Tooltip>
                              <Tooltip title={'Clear'}>
                                <Clear
                                  className={` ${classes.iconSearch} mt-0`}
                                  onClick={(e) => setFieldValue('field', '')}
                                />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <FormHelperText error>
                        {getIn(touched, 'field') && !values.field?.fieldName && getIn(errors, 'field')}
                      </FormHelperText>
                    </div>
                    <div className="col-lg-4 form-group">
                      <GuiTextField
                        margin="dense"
                        // className={`${classes.labelName} ${classes.inputLabel}`}
                        variant="outlined"
                        placeholder={`Enter new field name`}
                        label="New Field Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="newFieldName"
                        value={values.newFieldName}
                        error={getIn(touched, 'newFieldName') && getIn(errors, 'newFieldName')}
                        onChange={(e) => {
                          handleChange(e);
                          if (e.target.value) {
                            setCodePopover(true);
                          } else {
                            setCodePopover(false);
                          }
                          // setFieldValue("eventTactic", e.target.value);
                        }}
                        fullWidth
                        handleBlur={handleBlur}
                        required
                      />
                      <FormHelperText error>
                        {getIn(touched, 'newFieldName') && getIn(errors, 'newFieldName')}
                      </FormHelperText>
                      <div className="windowcode-popover Add-trigger-group-popover">
                        {codePopover &&
                          getFilterCodesData(values.newFieldName)?.map((data) => (
                            <MenuItem key={data?.nbFieldName}>{data?.nbFieldName}</MenuItem>
                          ))}
                      </div>
                    </div>
                    <div
                      className={`col-sm-6 col-md-4 col-xl-4 form-group ${classes.selectField}`}>
                      <FormControl
                        // margin="dense"
                        variant="outlined"
                        fullWidth

                      >
                        <InputLabel id="demo-simple-select-label">
                          Show Dashboard
                        </InputLabel>
                        <Select
                          fullWidth
                          name="showDashboard"
                          className="select-gender"
                          id="demo-simple-select"
                          labelId="demo-simple-select-label"
                          label=" Show Dashboard"
                          value={values.showDashboard || 'none'}
                          onChange={(e) => {
                            setFieldValue('showDashboard', e.target.value);
                          }}
                        >
                          <MenuItem value="none" key="none" disabled>
                            <span className="defaultSelected">Select Show Dashboard</span>
                          </MenuItem>
                          {options.map((option) => {
                            return (
                              <MenuItem value={option.value} key={option.key}>
                                {option.key}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div className="w-100 d-flex justify-content-center new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`mr-1 reset-btn ${classes.buttonRoot}`}
                      onClick={() => {
                        //   handleReset();
                        //   setSearchData({});
                        //   setSubmit(true)
                        resetForm();
                        //   sessionStorage.removeItem("searchNightJob");
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </>
              </Form>
            )}

          </>
        );
      }}
    </Formik>
  );
};

export default AddFieldForm;
